import React from 'react';
import '../styles/line.css';

export default function ClosedLine() {
  return (
    <div className="line-container">
      <div className="menu-wait-wrapper">
        <div className="menu-wait-outer">
          <div className="wait-text">
            <p>ただいまオンライン受付は<br /><b>時間外</b>です</p>
          </div>
        </div>
      </div>

      <div className="menu-wrapper">
        <div className="menu-outer">
          <div className="menu-off-btn">現在は受付できません</div>
        </div>
      </div>
    </div>
  );
}
